import { Component, ElementRef, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, interval, Subscription, switchMap, tap } from 'rxjs';
import { fadeInUp400ms } from 'src/@vex/animations/fade-in-up.animation';
import { stagger40ms } from 'src/@vex/animations/stagger.animation';
import { TableColumn } from 'src/@vex/interfaces/table-column.interface';
import { TrackingService } from 'src/app/shared/services/tracking.service';
declare let google: any;

@UntilDestroy()
@Component({
  selector: 'app-track-vehicle',
  templateUrl: './track-vehicle.component.html',
  styleUrls: ['./track-vehicle.component.scss'],
  animations: [fadeInUp400ms, stagger40ms],
})
export class TrackVehicleComponent implements OnInit {
  defaultLat: number = 24.356935;
  defaultLng: number = 46.344382;
  map: any;
  markers: google.maps.Marker[] = [];
  dataSource = new MatTableDataSource<any>(); 
  dataSourceOrders=new MatTableDataSource<any>();
  searchCtrl = new UntypedFormControl();
  isLoading:boolean=true;
  isRtl: boolean;
  columns: TableColumn<any>[] = [];
  ordersColumns: TableColumn<any>[] = [];

  pageSize = 10;
  inActivePageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50, 100, 250, 500,1000,5000,10000];
  isVehicleSelected:boolean=true;
  isOrdersSelected:boolean=false;
  vehiclesList = [];
  ordersList=[];
  //dottedPath:any=null;
  private intervalSubscription: Subscription;
  image = 'assets/img/TruckOnMap_1.png';
  marker_selected_img = 'assets/img/TruckOnMap_selected.png';
  private directionsRenderer!: google.maps.DirectionsRenderer;
  private directionsService!: google.maps.DirectionsService;


  constructor(private _elementRef: ElementRef, private translateService: TranslateService, private trackingService:TrackingService) {
    this.columns=[
    { label: this.translateService.instant("VEHICLE.TEXT.TEXT"), property: 'name', type: 'text', visible: true },
    { label: this.translateService.instant("PLAT_NUMBER.TEXT"), property: 'plateNumber', type: 'text', visible: true },
    { label: this.translateService.instant("ACTION.TEXT"), property: 'actions', type: 'button', visible: true },
  ];

  this.ordersColumns=[
    { label: this.translateService.instant("ORDER_NO.TEXT"), property: 'orderNumber', type: 'text', visible: true },
    { label: this.translateService.instant("CUSTOMERNAME.TEXT"), property: 'customerName', type: 'text', visible: true },
    { label: this.translateService.instant("CUSTOMER_ADDRESS.TEXT"), property: 'customerAddress', type: 'text', visible: true },
    { label: this.translateService.instant("DRIVER_NAME.TEXT"), property: 'driverName', type: 'text', visible: true },
    { label: this.translateService.instant("ACTION.TEXT"), property: 'actions', type: 'button', visible: true },
  ];
   }

  ngOnInit(): void {
    //// // debugger;
//     const start = { lat: 51.5074, lng: -0.1278 }; // London
// const end = { lat: 48.8566, lng: 2.3522 }; // Paris
//     this.getRoute(start, end); // Replace with your desired locations

    this.launchMap(this.defaultLat, this.defaultLng);
    this.isRtl = this.translateService.currentLang == 'ar'|| this.translateService.currentLang == 'ur'?true:false;
    this.loadTablesData().subscribe(data=>{ 
      //// // debugger;
      this.isLoading = false;
      this.addMarkers();});

      this.directionsService = new google.maps.DirectionsService();
    this.directionsRenderer = new google.maps.DirectionsRenderer();
    //this.dataSource.data = this.vehicles;
    //this.dataSourceOrders.data=this.orders;

// Set up an interval to call the method every 15 seconds
this.intervalSubscription = interval(15000)
.pipe(switchMap(() => {
  return this.loadTablesData();
}))
.subscribe((data) => {
      this.addMarkers(true);
});

    this.searchCtrl.valueChanges.pipe(
      untilDestroyed(this)
    ).subscribe(value => this.onFilterChange(value));
  }

  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }

  get visibleOrdersColumns() {
    return this.ordersColumns.filter(column => column.visible).map(column => column.property);
  }

  loadTablesData(){
    return forkJoin({
      vehiclesList: this.trackingService.GetAllVehiclesLocations(),
      ordersList: this.trackingService.GetAllReadyLoadingOrders(),
    }).pipe(
      tap(({ vehiclesList, ordersList }) => {
        // Set the data for each list
        //// // debugger;
        this.vehiclesList = vehiclesList.data;
        this.ordersList = ordersList.data;
        this.dataSource.data = this.vehiclesList;
        this.dataSourceOrders.data=this.ordersList;
      })
    );
  }

  // Initialize the map
  launchMap(lat: number, lng: number): void {
    const defaultCenter = { lat: lat, lng: lng };
    this.map = new google.maps.Map(this._elementRef.nativeElement.querySelector('#map'), {
      zoom: 15,
      center: defaultCenter,
    });
  }

  // Add markers to the map for each vehicle
  addMarkers(exception?): void {
    //let image = 'http://localhost:4200/assets/img/TruckOnMap_1.png';
    this.clearMarkers(exception)
    if(this.isVehicleSelected){
    this.vehiclesList.forEach((vehicle) => {
      //// // debugger;
      const lat=Number(vehicle?.gpsSystemData?.lastUpdate?.onLocation?.lat);
      const lng=Number(vehicle?.gpsSystemData?.lastUpdate?.onLocation?.lng);
      const marker = new google.maps.Marker({
        position: { lat: lat, lng: lng },
        map: this.map,
        title: vehicle.name,
        icon:this.image 
      });
      this.markers.push(marker);
    });}

    else if(this.isOrdersSelected){
      this.ordersList.forEach((order) => {
        const lat=Number(order.vehicleTrackingData.gpsSystemData.lastUpdate.onLocation.lat);
        const lng=Number(order.vehicleTrackingData.gpsSystemData.lastUpdate.onLocation.lng);
        const marker = new google.maps.Marker({
          position: { lat: lat, lng: lng },
          map: this.map,
          title: order.orderNumber,
          icon:this.image
        });
        this.markers.push(marker);
      });
    }
  }

  // Focus on the vehicle selected from the table
  focusVehicle(vehicle: any): void {
    // // debugger;
    //this.selectedVehicle = vehicle;
    this.clearPath();

    let lat=this.defaultLat;
    let lng=this.defaultLng;
    if(this.isVehicleSelected){
    lat=Number(vehicle?.gpsSystemData?.lastUpdate?.onLocation?.lat);
    lng=Number(vehicle?.gpsSystemData?.lastUpdate?.onLocation?.lng); 
  }  
  else if(this.isOrdersSelected){
    lat=Number(vehicle.vehicleTrackingData.gpsSystemData.lastUpdate.onLocation.lat);
    lng=Number(vehicle.vehicleTrackingData.gpsSystemData.lastUpdate.onLocation.lng);
  }
    
    this.map.setCenter({ lat, lng });
    this.map.setZoom(18);
    
    //// // debugger;
    const selectedMarker = this.markers.find(
      (marker) => marker.getTitle() === (this.isVehicleSelected?vehicle.name:vehicle.orderNumber)
    );
    if (selectedMarker) {
      selectedMarker.setAnimation(google.maps.Animation.BOUNCE);
      setTimeout(() => selectedMarker.setAnimation(null), 4000); // Stop bouncing after 4 seconds
    }

    if(this.isOrdersSelected && vehicle.customerAddressLocation.length !=0){
      //// // debugger;
      const start={lat:lat,lng:lng};
      const [endLat,endlng] = vehicle.customerAddressLocation.split(',');
      const end={ lat:parseFloat(endLat) , lng:parseFloat(endlng)};
      //this.getRoute(start, end);
      // Add directions
      this.renderDirections(this.map, start, end);
      //this.createDottedPolyLine(start,end);
      const marker = new google.maps.Marker({
        position: { lat: parseFloat(endLat), lng: parseFloat(endlng) },
        map: this.map,
        title: vehicle.customerAddressName,
        //icon:this.marker_selected_img,
        //icon: "http://maps.google.com/mapfiles/ms/icons/green-dot.png", // Blue marker
      });
      this.markers.push(marker);
    }
  }

  onFilterChange(value: string) {
    if (!this.dataSource) {
      return;
    }
    //this.currentPage=0;

    this.isVehicleSelected?this.dataSource.filter = value.trim().toLowerCase():this.dataSourceOrders.filter=value.trim().toLowerCase(); // Apply lowercase, trimmed filtering
    // this.filteredDataSearch=value==''?null:value;
    // this.loadData(value,this.filteredDataStatus);   
 }


renderDirections(map: google.maps.Map, start: google.maps.LatLngLiteral, end: google.maps.LatLngLiteral): void {
  
  

    this.directionsRenderer.setMap(map);

  const request: google.maps.DirectionsRequest = {
    origin: new google.maps.LatLng(start.lat, start.lng),
    destination: new google.maps.LatLng(end.lat, end.lng),
    travelMode: google.maps.TravelMode.DRIVING,
  };

  this.directionsService.route(request, (result, status) => {
    // debugger
    if (status === google.maps.DirectionsStatus.OK) {
      this.directionsRenderer.setDirections(result);
    } else {
      console.error('Directions request failed due to ', status);
    }
  });
}
 // Create a dotted polyline
//  createDottedPolyLine(start: any, end: any) {
//  this.dottedPath = new google.maps.Polyline({
//   path: [start, end],
//   geodesic: true,
//   strokeColor: "#FF0000",
//   strokeOpacity: 0, // Make the solid line invisible
//   icons: [
//     {
//       icon: {
//         path: "M 0,-1 0,1", // Dash pattern
//         strokeOpacity: 1,
//         scale: 4,
//       },
//       offset: "0",
//       repeat: "10px",
//     },
//   ],
//   strokeWeight: 2,
// });
// this.dottedPath.setMap(this.map);
// }

// createDirectionalPath(start: any, end: any) {
//   const directionsService = new google.maps.DirectionsService();
//   const directionsRenderer = new google.maps.DirectionsRenderer();

//   directionsRenderer.setMap(this.map); // Set the renderer to the map

//   const request = {
//     origin: start, // Start point (New York)
//     destination: end, // End point (another place)
//     travelMode: google.maps.TravelMode.DRIVING, // You can use DRIVING, WALKING, BICYCLING, or TRANSIT
//   };

//   // Request directions
//   directionsService.route(request, (result, status) => {
//     if (status === google.maps.DirectionsStatus.OK) {
//       directionsRenderer.setDirections(result); // Display the route
//     } else {
//       console.error('Directions request failed due to ' + status);
//     }
//   });
// }

 toggleTables(vehicleFlag:boolean){
  this.isVehicleSelected=vehicleFlag;
  this.isOrdersSelected=!vehicleFlag;
  this.clearMap();
  this.addMarkers();
 }

 // Function to clear all markers
clearMap() {
  this.clearMarkers();
  this.clearPath();
}

clearMarkers(exception?:boolean){
  
  if(exception){
    this.markers = this.markers.filter((marker) => {
      if (marker.getIcon() == this.image) {
        marker.setMap(null); // Remove marker from map
        return false; // Remove from the array
      }
      return true; // Keep in the array
    });
  }else{
    for (let marker of this.markers) {
      marker.setMap(null); // Remove marker from the map
    }
    this.markers = []; // Clear the markers array
  
  }
}

checkIfDirectionsDrawn(): boolean {
  const directions = this.directionsRenderer.getDirections();
  return directions !== null;
}

clearPath(){
  if (this.checkIfDirectionsDrawn()) {
    //console.log('A route is already drawn. Clearing the map...');
    this.directionsRenderer.setDirections(null);
  }
}

 toggleColumnVisibility(column, event) {
  event.stopPropagation();
  event.stopImmediatePropagation();
  column.visible = !column.visible;
}
}
